import { render, staticRenderFns } from "./ItemsList.vue?vue&type=template&id=5295c462&"
import script from "./ItemsList.vue?vue&type=script&lang=ts&"
export * from "./ItemsList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports